import Vue from 'vue'

Vue.mixin({
  computed: {
    regulator() {
      return this.$store.state.common.regulator
    },
    isFromApp() {
      return this.$store.state.common.isFromApp
    },
    GLOBAL_DOMAIN_WEBSITE() {
      return this.$store.state.regulator.domainWebSite || this.$config.info.getUrl(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEGCN() {
      return this.$config.info.getUrlGCN(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITECN() {
      return this.$config.info.getUrlCn(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITETW() {
      return this.$config.info.getUrlTw(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEID() {
      return this.$store.state.regulator.domainWebSiteId || this.$config.info.getUrlId(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEEU() {
      return this.$store.state.regulator.domainWebSiteEu || this.$config.info.getUrlEu(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEIT() {
      return this.$config.info.getUrlIT(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEVN() {
      return this.$config.info.getUrlVn(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEFREU() {
      return this.$config.info.getUrlFrEu(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEIR() {
      return this.$store.state.regulator.domainWebSiteIr || this.$config.info.getUrlIr(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEIRPRO() {
      return this.$store.state.regulator.domainWebSiteIrPro || this.$config.info.getUrlIrPro(this.regulator)
    },
    GLOBAL_DOMAIN_WEBSITEMY() {
      return this.$config.info.getUrlMy(this.regulator)
    },
    GLOBAL_REFERRAL_WEBSITERU() {
      return this.$config.info.getUrlRu(this.regulator)
    },
    GLOBAL_REFERRAL_WEBSITEIRAQ() {
      return this.$config.info.getUrlIraq(this.regulator)
    },
    GLOBAL_REFERRAL_WEBSITE() {
      return this.$store.state.regulator.referralSite || this.$config.info.getUrl(this.regulator)
    },
    GLOBAL_REFERRAL_WEBSITECAMBODIA() {
      return this.$config.info.getUrlKh(this.regulator)
    },
    GLOBAL_REFERRAL_WEBSITEJA() {
      return this.$store.state.regulator.domainWebSiteJp || this.$config.info.getUrlJa(this.regulator)
    },
    GLOBAL_CONTACT_EMAIL() {
      return this.$store.state.regulator.contactEmail || this.$config.info.getEmail(this.regulator)
    },
    GLOBAL_DEPOSIT_EMAIL() {
      return this.$store.state.common.lang === 'th'
        ? this.GLOBAL_CONTACT_EMAIL
        : this.$config.info.getDepositEmail(this.regulator)
    },
    GLOBAL_WITHDRAWAL_EMAIL() {
      return this.$config.info.getWithdrawalEmail(this.regulator)
    },
  },
  methods: {
    showLiveChat() {
      try {
        zE('messenger', 'open')
      } catch (error) {
        console.log('messenger', error)
      }
    },
  },
})
